<template>
    <div style="height: 700px; padding: 20px; background-color: white; overflow-y: auto; border-radius: 10px; border: black solid 2px;">
        <v-card-title style="text-align: center;">Search Supplier</v-card-title>
        <v-text-field
            :style="{
                padding: '0 20px',
                width: '350px'
            }"
            v-model="search"
            label="Search Supplier"
            variant="solo-filled"
            clearable
            @update:modelValue="handleSearchUpdate"
            ref="searchInput"
        >
            <template #append-inner>
                <v-icon
                    :style="{ opacity: '1' }"
                    color="black"
                    icon="mdi:mdi-magnify"
                    theme="light"
                    right
                />
            </template>
        </v-text-field>

        <div class="part-row-headers">
            <div class="header row-one row">
                Name
            </div>
            <div class="header row-two row">
                Address
            </div>
        </div>

        <div class="part-row" v-for="supplier in supplierArray" :key="supplier.code" @click="selectSupplier(supplier.Name, supplier.VendorNum)">
            <div class="row-one row data">
                {{ supplier.Name }}
            </div>
            <div class="row-two row data">
                {{ supplier.Address2 }}
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "SupplierSearch",
    emits: ["supplierReceived"],
    props: {},
    data: () => ({
        search: "",
        supplierArray: []
    }),
    watch: {},
    computed: {},
    created() {},
    async mounted () {
        await this.fetchSupplierOptions();
        this.$refs.searchInput.focus();
    },
    methods: {
        handleSearchUpdate() {
            setTimeout(() => {
                this.fetchSupplierOptions()
            }, 50)
        },
        async fetchSupplierOptions() {
            try {
                axios.get(route("legacy-api.suppliersSearch", {
                    search: this.search
                })).then((res) => {
                    this.supplierArray = res.data
                });
            } catch (err) {
                console.log(err);
            }
        },
        selectSupplier(name, code) {
            this.$emit("supplierReceived", {name: name, code: code});
            this.search = "";
        }
    },
};
</script>

<style scoped>
    .part-row {
        display: flex;
        cursor: pointer;
    }
    .part-row-headers {
        display: flex;
    }
    .part-row:hover {
        background-color: rgb(211, 211, 211);
    }
    .header {
        text-align: center;
        font-weight: 600;
        border-bottom: 2px;
    }
    .row {
        border-bottom: 0; 
        border-top: 1px;
        border-right: 1px; 
        border-color: gray; 
        border-style: solid;
    }
    .data {
        font-size: 13px; 
        padding: 5px;
    }
    .row-one {
        border-left: 1px;
        width: 30%;
    }
    .row-two {
        width: 70%; 
        border-left: 0;
    }
</style>
